// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"a7170863","111":"a655442c","320":"0c46507c","457":"f992cf5b","506":"15888891","571":"701047a2","635":"d66b800c","868":"4c42b742"}[chunkId] + ".chunk.js";
};